​​
<template>
    <div class="scrollItem">
        <!-- 左箭头按钮 -->
        <!-- <div
            class="left"
            style="width: 50px; height: 154px; background-color: #f5f5f5; position: relative;"
        >
            <div class="leftBtn" @click="throttle(PrevFun)">&larr;</div>
        </div> -->
        <!-- 企业内容 -->
        <div
            class="SwiperBox"
            ref="SwiperBox"
            @mouseenter="MouseFun('移入')"
            @mouseleave="MouseFun('移出')"
        >
            <!-- 图片 -->
            <div
                class="imgBox"
                :style="{ left: `-${leftVal}px`, transition: `${ition}s` }"
            >
                <div
                    class="Swiper-items"
                    v-for="(item, index) in companyList"
                    :key="item.index"
                    style="display: flex"
                >
                    <div class="photo-box" @click="getyxqyzsDetail(item)">
                        <a class="photo">
                            <img
                                :src="
                                    downloadUrl +
                                    item.qytp
                                "
                                alt=""
                                class="picture"
                            />
                        </a>
                        <div class="dect">{{ item.title }}</div>
                    </div>
                </div>
                <!-- 复制第一张放到最后,以实现无缝无线循环滚动效果 -->
                <div
                    class="Swiper-items"
                    v-for="(item, index) in companyList"
                    :key="item.id"
                    style="display: flex"
                >
                    <div class="photo-box">
                        <a class="photo">
                            <img
                                :src="
                                    downloadUrl +
                                    item.qytp
                                "
                                alt=""
                                class="picture"
                            />
                        </a>
                        <div class="dect">{{ item.title }}</div>
                    </div>
                </div>
            </div>

            

            <!-- 下方指示点容器 -->
            <!-- <div class="instBox">
              <div @click="instFun(index)" v-for="(item,index) in imgList.length" :key="index"
              :class="['inst',index==imgShow?'instActv':'']">
              </div>
            </div> -->
        </div>
        <!-- 右箭头按钮 -->
        <!-- <div class="right" style="width: 50px; height: 154px; background-color: #f5f5f5; position: relative;">
                <div class="rightBtn" @click="throttle(NextFun)">&rarr;</div>
            </div> -->
    </div>
</template>

<script>
import { Server } from "@/server";

export default {
    data() {
        return {
            imgData: [],
            leftVal: 0, // 轮播图盒子的偏移值
            flag: true, // 用来节流防止重复点击j
            start: null, // 自动执行下一张定的时器
            imgWidth: 280, // 在这里填写你需要的图片宽度
            ition: 1, // 设置轮播图过度时间
            companyList: [], // 优秀企业的数组
            downloadUrl:''
        };
    },
    created() {
        // this.getCompany();
    },
    computed: {
        // 敲黑板，分组轮播的重点来了！！！！！！！！！！！！！！！！！！！！
        imgList() {
            // 数组分割
            let arr = [];
            let num = 3; // 填写需要分割成几个一组的数量
            if (this.companyList.length && this.companyList != null) {
                for (let i = 0; i < this.companyList.length; i += num) {
                    arr.push(this.companyList.slice(i, i + num));
                }
                console.log(arr.length);
            }
            return arr;
        },
    },
    mounted() {
        // this.imgWidth = this.$refs.SwiperBox.offsetWidth // 自动获取轮播图盒子宽度
        this.scrollView(); // 偷偷告诉大家一个小秘密,JavaScript是原生支持中文命名函数或变量的哦
        // this.getCompany();
        this.downloadUrl = this.$downloadUrl
    },
    methods: {
        // 这里定义一个鼠标移入移出事件，鼠标悬停时停止自动轮播，鼠标移出则重新执行自动轮播
        MouseFun(type) {
            // 停止定时器            // 重新执行定时器
            type == "移入" ? clearTimeout(this.start) : this.scrollView();
        },
        // 此为自动轮播定时器
        scrollView() {
            this.start = setInterval(() => {
                this.NextFun();
            }, 2000);
        },
        getCompany() {
            Server.infoList({
                type: 4,
                status: 1,
                pageSize: 10,
                pageNo: 1,
            }).then((res) => {
                var list = []
                if (res.code == 200) {
                    list = res.result.records;
                }
                list.forEach(item => {
                    if(item.qytp != "") {
                        this.companyList.push(item)
                    }
                })
                console.log(this.companyList)
            });
        },
        // 优秀企业详情
        getyxqyzsDetail(item) {
            this.$router.push({
                path: "/greatCompany",
                query: {
                    type: item.type,
                    id: item.id,
                },
            });
        },
        // 这里通过额外封装的节流函数触发 PrevFun() 和 NextFun(),以达到防止重复点击的效果
        throttle(fun) {
            if (this.flag) {
                this.flag = false;
                fun(); // 此为模板中传递进来的PrevFun()或NextFun()函数
                setTimeout(() => {
                    this.flag = true;
                }, 1000); // 节流间隔时间
            }
        },
        // 上一张
        PrevFun() {
            if (this.leftVal == 0) {
                // 判断显示的图片 是 第一张时执行
                // this.imgList.length是指循环图片数组的图片个数
                this.ition = 0; // 将过渡时间变成0，瞬间位移到最后一张图
                // this.imgShow = this.imgList.length - 1; // 将高亮小点改为最后一张图
                this.leftVal = this.imgList.length * this.imgWidth; // 瞬间移动
                setTimeout(() => {
                    // 通过延时障眼法,归原过渡时间,执行真正的“上一张”函数
                    this.ition = 0.8;
                    this.leftVal -= this.imgWidth;
                }, this.ition * 1000);
            } else {
                // 判断显示的图片 不是 第一张时执行
                this.ition = 0.8;
                this.leftVal -= this.imgWidth;
                // this.imgShow--;
            }
        },
        // 下一张
        NextFun() {
            if (this.leftVal == (this.imgList.length - 1) * this.imgWidth) {
                // 判断显示的图片 是 最后一张时执行
                this.ition = 0.8;
                this.leftVal += this.imgWidth;
                // this.imgShow = 0;
                setTimeout(() => {
                    this.ition = 0;
                    this.leftVal = 0;
                }, this.ition * 4000);
            } else {
                // 判断显示的图片 不是 最后一张时执行
                this.ition = 0.8;
                this.leftVal += this.imgWidth;
                // this.imgShow++;
            }
        },
    },
};
</script>

<style lang="less">
.el-breadcrumb {
    padding: 20px 0 10px 10px;
}
.scrollItem {
    display: flex;
    width: 1100px;
    position: relative;
    margin: 0 auto;
    // left: -40px;
}
/* 图片容器样式 */
.SwiperBox {
    position: relative;
    width: 1100px;
    height: 160px;
    box-sizing: border-box;
    cursor: pointer;
    overflow: hidden;
    // border: 1px solid #eee;
}
.imgBox {
    margin-top: 10px;
    position: absolute;
    top: 0px;
    left: 0px;
    min-width: 500px;
    // height: 300px;
    display: flex;
    justify-content: flex-start;
}
/* 图片默认样式 */
.Swiper-items {
    flex-shrink: 0;
    width: 280px;
    // height: 300px;
    display: flex;
    // justify-content: space-around;
    align-items: center;
}
.swiper-item {
    flex-shrink: 0;
    width: 280px;
    // height: 300px;
    display: flex;
    // justify-content: space-around;
    align-items: center;
}

.Swiper-item img {
    width: 80px;
    height: 160px;
}
/* 两个按钮共有的样式,也可直接使用箭头图片替代 */
.leftBtn,
.rightBtn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(109, 109, 109, 0.445);
    color: #fff;
    border-radius: 50%;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
}
// .leftBtn {
//     left: 10px;
// }
// .rightBtn {
//     right: 10px;
// }
// /* 下方指示器盒子 */
// .instBox {
//     position: absolute;
//     left: 50%;
//     transform: translateX(-50%);
//     bottom: 10px;
//     display: flex;
// }
/* 小圆点 */
.inst {
    width: 10px;
    height: 10px;
    border: 1px solid #ccc;
    margin-right: 8px;
    background: #fff;
    border-radius: 50%;
    cursor: pointer;
}
.inst:last-child {
    margin-right: 0px;
}
.instActv {
    border: 1px solid #ff0000;
    background: #ff0000;
}
/* #app{
    width: 100%;
    padding: 120px;
    display: flex;
    justify-content: center;
    padding:80px 0px;
  } */

.photo-box {
    width: 250px;
    height: 100%;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    .photo {
        width: 100%;
        display: block;
        .picture {
            width: 250px;
            height: 135px;
            background-color: #f0f0f0;
        }
    }
    .dect {
        width: 100%;
        color: #666;
        font-size: 14px;
        margin: 10px 0;
        text-align: center;

        display: none;
    }
}
</style>
